<template>
  <v-dialog
    max-width="480px"
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card class="mb-0">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Imprimir Turnos</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-if="!esEliminado">
        <v-radio-group v-model="radios" column>
          <v-radio
            v-if="habilitaTurnoDiario"
            label="Turnero diario de la cancha"
            value="diario"
          ></v-radio>
          <v-radio
            label="Sin observaciones (Formato Vertical)"
            value="sinObs"
          ></v-radio>
          <v-radio
            :label="`Con observaciones (Formato Horizontal)`"
            value="conObs"
          ></v-radio>
          <v-radio
            label="Con fecha de nacimiento (Formato Vertical)"
            value="conFN"
          ></v-radio>
          <v-radio
            label="Con teléfono (Formato Vertical)"
            value="conTel"
          ></v-radio>
          <v-radio
            label="Informe para liquidar alquileres"
            value="liquidar"
          ></v-radio>
        </v-radio-group>
      </v-card-text>

      <v-card-text v-else>
        <v-radio-group v-model="radios" column>
          <v-radio label="Turnos Eliminados" value="eliminados"></v-radio>
        </v-radio-group>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="grey lighten-1" @click.stop="show = false"
          >Cancelar</v-btn
        >
        <v-btn color="warning" @click.stop="imprimir">Imprimir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>
import jsPDF from "jspdf";
import autotable from "jspdf-autotable";
import imprimirTurnosDiarios from "./ImpresionesListados/turrnosDiarios.js";
export default {
  data: (vm) => ({
    radios: "",
  }),
  props: [
    "visible",
    "listaTurnos",
    "fechaDesde",
    "fechaHasta",
    "esEliminado",
    "profesional",
  ],
  computed: {
    show: {
      get() {
        if (this.visible) this.setearModels();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
    habilitaTurnoDiario() {
      const allSameDateAndProfessional =
        new Set(
          this.listaTurnos.map(
            ({ fechaTurnoString, idProfesional }) =>
              `${fechaTurnoString}-${idProfesional}`
          )
        ).size === 1;
      return allSameDateAndProfessional;
    },
  },
  methods: {
    setearModels() {
      this.opcionesSeleccionadas = this.opciones;
      if (this.esEliminado) {
        this.radios = "eliminados";
      } else {
        this.radios = this.habilitaTurnoDiario ? "diario" : "sinObs";
      }
    },

    vaciarModels() {
      this.opcionesSeleccionadas = [];
    },
    imprimir() {
      if (this.radios === "diario") {
        const nombreInstitucion =
          this.$store.state.usuario.institucion.nombreInstitucion;
        const fecha = this.formatDate(this.fechaDesde);
        imprimirTurnosDiarios(this.listaTurnos, nombreInstitucion, fecha);
        return;
      }

      var source = this.listaTurnos;
      let rows = [];
      let columnHeader = [];

      if (this.radios == "sinObs") {
        var doc = new jsPDF();
        columnHeader = [
          "Dia",
          "Fecha",
          "Hora",
          "Dni",
          "Jugador",
          "Cancha",
          "Estado",
        ];

        source.forEach((element) => {
          var temp = [
            element.diaSemana,
            element.fechaTurnoString,
            element.horaInicioString,
            element.dniPaciente,
            element.nombrePaciente,
            element.nombreCancha,
            element.estadoTurnoString,
          ];
          rows.push(temp);
        });
      } else {
        if (this.radios == "conObs") {
          var doc = new jsPDF("landscape");
          columnHeader = this.$store.state.usuario.institucion.esEmpresa
            ? [
                "Dia",
                "Fecha",
                "Hora",
                "Dni",
                "Jugador",
                "Cancha",
                "Observaciones",
              ]
            : [
                "Dia",
                "Fecha",
                "Hora",
                "Dni",
                "Jugador",
                "Cancha",
                "Observaciones",
              ];

          source.forEach((element) => {
            var temp = [
              element.diaSemana,
              element.fechaTurnoString,
              element.horaInicioString,
              element.dniPaciente,
              element.nombrePaciente,
              element.nombreCancha,
              element.observacionesTurno,
            ];
            rows.push(temp);
          });
        } else if (this.radios == "conFN") {
          var doc = new jsPDF();
          columnHeader = [
            "Dia",
            "Fecha",
            "Hora",
            "Dni",
            "Jugador",
            "Fecha Nac.",
            "Cancha",
          ];

          source.forEach((element) => {
            var temp = [
              element.diaSemana,
              element.fechaTurnoString,
              element.horaInicioString,
              element.dniPaciente,
              element.nombrePaciente,
              element.fechaNacimientoString,
              element.nombreCancha,
            ];
            rows.push(temp);
          });
        } else if (this.radios === "conTel") {
          var doc = new jsPDF();
          columnHeader = [
            "Dia",
            "Fecha",
            "Hora",
            "Dni",
            "Jugador",
            "Teléfono",
            "Cancha",
          ];

          source.forEach((element) => {
            var temp = [
              element.diaSemana,
              element.fechaTurnoString,
              element.horaInicioString,
              element.dniPaciente,
              element.nombrePaciente,
              element.celular,
              element.nombreCancha,
            ];
            rows.push(temp);
          });
        } else if (this.radios === "eliminados") {
          var doc = new jsPDF("landscape");
          columnHeader = [
            "Dia",
            "Fecha",
            "Hora",
            "Dni",
            "Jugador",
            "Cancha",
            "Estado",
            "Usuario Elimina",
            "Fecha Elimina",
          ];

          source.forEach((element) => {
            var temp = [
              element.diaSemana,
              element.fechaTurnoString,
              element.horaInicioString,
              element.dniPaciente,
              element.nombrePaciente,
              element.nombreCancha,
              element.estadoTurnoString,
              element.usuarioEliminacion,
              element.fechaEliminacionString,
            ];
            rows.push(temp);
          });
        } else if (this.radios === "liquidar") {
          var doc = new jsPDF();
          columnHeader = [
            "Dia",
            "Fecha",
            "Hora",
            "Cancha",
            "Valor Turno",
          ];

          source.forEach((element) => {
            var temp = [
              element.diaSemana,
              element.fechaTurnoString,
              element.horaInicioString,
              element.nombreCancha,
              element.totalConsumoTurno || "—",
            ];
            rows.push(temp);
          });

          // Fila de total
          var sumaTotal = source.reduce((acc, el) => {
            if (el.totalConsumoTurno && el.totalConsumoTurno !== "—") {
              return acc + parseFloat(el.totalConsumoTurno.replace("$", ""));
            }
            return acc;
          }, 0);
          rows.push(["", "", "", "TOTAL", "$" + sumaTotal.toFixed(2)]);
        }
      }
      //doc.text('Listado de Turnos',20,10);
      var nombreInstitucion =
        this.$store.state.usuario.institucion.nombreInstitucion
          .toString()
          .trim();

      doc.setFontSize(12);
      doc.text(nombreInstitucion, 13, 10);
      doc.setFontSize(10);
      doc.text(
        "Fecha Desde: " +
          this.formatDate(this.fechaDesde) +
          "  -  " +
          "Fecha Hasta: " +
          this.formatDate(this.fechaHasta),
        13,
        16
      );

      doc.setFontSize(16);
      doc.text(
        this.radios === "liquidar" ? "Informe para Liquidar" : "Listado de Turnos",
        doc.internal.pageSize.getWidth() / 2, 33, {
        align: "center",
      });
      var totalRows = rows.length;
      doc.autoTable(columnHeader, rows, {
        startY: 39,
        didParseCell: function (table) {
          if (table.section === "head") {
            table.cell.styles.fillColor = "#c4c5c5";
          }
          // Última fila (total) en negrita
          if (table.section === "body" && table.row.index === totalRows - 1) {
            table.cell.styles.fontStyle = "bold";
          }
        },
      });
      window.open(doc.output("bloburl"), "_blank");

      //doc.save('turnos.pdf');
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
